import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, saveToken } from '../api';
import { useAppContext } from '../context/AppContext';

export default function LoginScreen() {
  const navigate = useNavigate();
  const { loadUserProfile } = useAppContext();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem('login_form');
    if (saved) { try { setForm(p => ({ ...p, email: JSON.parse(saved).email || '' })); } catch {} }
  }, []);

  const updateField = (field, value) => {
    setForm(p => ({ ...p, [field]: value }));
    if (errors[field]) setErrors(p => ({ ...p, [field]: null }));
    if (field === 'email') localStorage.setItem('login_form', JSON.stringify({ email: value }));
  };

  const validate = () => {
    const e = {};
    if (!form.email.trim()) e.email = 'Введите email';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Некорректный email';
    if (!form.password) e.password = 'Введите пароль';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setErrorMsg('');
    try {
      const data = await api.auth.login({ email: form.email, password: form.password });
      saveToken(data.access_token);
      await loadUserProfile();
    } catch (err) {
      setErrorMsg(err.status === 401 || err.status === 403 ? 'Неверный email или пароль' : 'Нет соединения с сервером');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ flex: 1, backgroundColor: 'var(--bg)', minHeight: '100vh', paddingHorizontal: 24 }}>
      <form onSubmit={handleLogin} style={{ paddingLeft: 24, paddingRight: 24 }}>
        <div style={{ textAlign: 'center', marginTop: 40, marginBottom: 8 }}>
          <img src="/logo.jpg" alt="Акватория" style={{ width: 80, height: 80, borderRadius: 20, objectFit: 'cover' }} />
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 'bold', color: 'var(--primary)', marginTop: 8 }}>Вход</h1>
        <p style={{ fontSize: 16, color: 'var(--text-light)', marginBottom: 24 }}>Введите данные для входа</p>

        <label style={labelStyle}>Email</label>
        <input
          type="email" placeholder="example@mail.ru"
          value={form.email} onChange={e => updateField('email', e.target.value)}
          autoCapitalize="none" autoComplete="email"
          style={{ ...inputStyle, borderColor: errors.email ? '#FF3B30' : 'var(--border)' }}
        />
        {errors.email && <p style={errorStyle}>⚠ {errors.email}</p>}

        <label style={labelStyle}>Пароль</label>
        <input
          type="password" placeholder="Ваш пароль"
          value={form.password} onChange={e => updateField('password', e.target.value)}
          autoComplete="current-password"
          style={{ ...inputStyle, borderColor: errors.password ? '#FF3B30' : 'var(--border)' }}
        />
        {errors.password && <p style={errorStyle}>⚠ {errors.password}</p>}

        {errorMsg && <p style={{ ...errorStyle, marginTop: 8 }}>⚠ {errorMsg}</p>}

        <button type="submit" disabled={loading} style={{ ...btnStyle, opacity: loading ? 0.6 : 1, marginTop: 24 }}>
          {loading ? 'Вход...' : 'Войти'}
        </button>

        <div style={{ textAlign: 'center', paddingTop: 16 }}>
          <span onClick={() => navigate('/forgot-password')} style={linkStyle}>Забыли пароль?</span>
        </div>
        <div style={{ textAlign: 'center', paddingTop: 8, paddingBottom: 16 }}>
          <span onClick={() => navigate('/register')} style={{ ...linkStyle, color: 'var(--primary)', fontWeight: 600 }}>
            Нет аккаунта? Зарегистрироваться
          </span>
        </div>
      </form>
    </div>
  );
}

const labelStyle = { display: 'block', fontSize: 15, fontWeight: 600, color: 'var(--text)', marginBottom: 6, marginTop: 8 };
const inputStyle = { display: 'block', width: '100%', backgroundColor: 'var(--input-bg)', borderRadius: 12, padding: '12px 16px', fontSize: 15, color: 'var(--text)', border: '1.5px solid var(--border)', outline: 'none' };
const errorStyle = { fontSize: 13, color: '#FF3B30', marginTop: 4 };
const btnStyle = { display: 'block', width: '100%', backgroundColor: 'var(--primary)', padding: '14px', borderRadius: 14, color: '#FFF', fontSize: 16, fontWeight: 700, textAlign: 'center' };
const linkStyle = { fontSize: 15, color: 'var(--text-light)', cursor: 'pointer' };
